interface PendriveSectionProps {
  onWhatsAppClick: () => void;
}

export default function PendriveSection({ onWhatsAppClick }: PendriveSectionProps) {
  return (
    <section id="pendrive" className="py-16 bg-gradient-to-br from-gray-50 to-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
            🎵 Músicas Selecionadas Só as Melhores! 🎵
          </h2>
          <div className="w-20 h-1 bg-gradient-to-r from-yellow-500 to-orange-600 mx-auto mb-6"></div>
          <p className="text-base md:text-lg text-gray-600 max-w-2xl mx-auto">
            Leve para casa as melhores músicas selecionadas em pendrive!
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="relative rounded-3xl overflow-hidden shadow-2xl">
            <img 
              alt="Pendrive Flashback - Músicas Selecionadas" 
              className="w-full h-auto object-cover" 
              src="https://static.readdy.ai/image/41dcaa27e5052b6465e437b1c282b5c6/5ec020b6b986d75aa7dc7d3d8e6e77ff.png"
            />
          </div>

          <div className="mt-8 text-center">
            <div className="bg-gradient-to-r from-yellow-50 to-orange-50 p-8 rounded-2xl">
              <h3 className="text-2xl font-bold text-gray-800 mb-4">
                💿 Adquira Já Seu Pendrive Musical! 💿
              </h3>
              <div className="grid md:grid-cols-2 gap-6 mb-6 max-w-2xl mx-auto">
                <div className="bg-white p-6 rounded-xl shadow-lg">
                  <div className="text-3xl font-bold text-yellow-600 mb-2">8GB</div>
                  <div className="text-gray-700 mb-2">Mais de 500 Músicas</div>
                  <div className="text-4xl font-bold text-green-600">R$ 100,00</div>
                </div>
                <div className="bg-white p-6 rounded-xl shadow-lg">
                  <div className="text-3xl font-bold text-orange-600 mb-2">16GB</div>
                  <div className="text-gray-700 mb-2">Mais de 1.500 Músicas</div>
                  <div className="text-4xl font-bold text-green-600">R$ 130,00</div>
                </div>
              </div>
              <p className="text-base text-gray-700 mb-6">
                Músicas selecionadas com qualidade e variedade para você curtir onde estiver!
              </p>
              <button 
                onClick={onWhatsAppClick}
                className="bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white px-8 py-4 rounded-full text-lg font-bold transition-all transform hover:scale-105 shadow-xl cursor-pointer whitespace-nowrap flex items-center justify-center mx-auto"
              >
                <i className="ri-whatsapp-line mr-2 text-xl"></i>
                Comprar Pendrive pelo WhatsApp
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}